import { render } from "./StageDocumentsModal.vue?vue&type=template&id=2343a8db&scoped=true&ts=true&lang=pug"
import script from "./StageDocumentsModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./StageDocumentsModal.vue?vue&type=script&lang=ts&setup=true"

import "./StageDocumentsModal.vue?vue&type=style&index=0&id=2343a8db&lang=scss"
import "./StageDocumentsModal.vue?vue&type=style&index=1&id=2343a8db&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2343a8db"]])

export default __exports__